module.exports = __webpack_public_path__ + "img/Etihad-Airways.bbf35a65.png";